export default __webpack_public_path__ + "static/media/num-6.685810c5.svg";